/* CacheBuster component */
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getSedesAction,
} from '../../../state/actions/creators/sedes/sedes.actioncreator';

class StorePreloader extends Component {
  componentDidMount() {
    const { getSedesAction } = this.props;
    getSedesAction(1, 0, 9999);
  }

  render() {
    return null;
  }
}

StorePreloader.propTypes = {
  getSedesAction: PropTypes.func.isRequired,
};

function mapStateToProps({ sedes }) {
  return {
    sedes,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getSedesAction,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StorePreloader);
